import axios from 'axios'
import { api } from '@/services/config'
import moment from 'moment'
import store from '@/store'
import { mixin } from '@/mixins/helper'
import router from '../../router'

const addEdit = {
  namespaced: true,
  state: () => ({
    addKbli: false,
    subKbliEdit: false,
    showEditInfo: false,

    addIujp: false,
    addIujptl: false,
    addSbujk: false,
    addInuBbm: false,
    addSiupal: false,

    choosedIujp: [],
    choosedSbujk: [],
    choosedIujptl: [],
    choosedInubbm: [],
    choosedSiupal: [],

    informasi: {},
    vendor_id: '',
    vendorName: '',
    pemilikBank: '',
    badan_usaha_id: '',
    tglBerdiri: '',

    isupplier_code: '',
    ariba_code: '',
    bce_code: '',
    gems_code: '',
    bkes_code: '',
    address: '',

    provinsiAsing: '',
    kotaAsing: '',
    kodeposAsing: '',
    choosedCountry: null,
    choosedProvince: null,
    choosedCity: null,
    choosedDistric: null,
    choosedVillage: null,
    kodepos: '',

    phoneCode: '',
    phoneNumber: '',
    emailPerusahaan: '',
    selectedBank: '',
    bankBranchOffice: '',
    mataUang: '',
    accountNumber: '',
    npwpBank: '',

    afiliasi_bce: 0,
    afiliasi_gems: 0,
    afiliasi_bkes: 0,
    relasi_desc: null,
    relasi_group: null,
    relasi_nama: null,
    relasi_jabatan: null,
    relasi_departemen: null,

    iujp: [],
    iujptl: [],

    isAddPic: false,
    picDetail: null,

    isAddDirektur: false,
    direkturDetail: null,

    isAddKomisaris: false,
    komisarisDetail: null,

    isAddPemilikSaham: false,
    pemilikSahamDetail: null,
    totalSaham: 0,
  }),
  mutations: {
    ADD_EDIT_MODAL(state, data) {
      state[data.name] = data.status
    },
    SET_STATE_DATA(state, data) {
      state[data.name] = data.value
    },
    SET_INFO(state, info) {
      state.informasi = info

      state.vendorName = info.nama_vendor
      state.badan_usaha_id = info.badan_usaha.id
      state.tglBerdiri = mixin.methods.formatDateInput(info.tanggal_berdiri)

      state.isupplier_code = info.isupplier_code
      state.ariba_code = info.ariba_code
      state.bce_code = info.bce_code
      state.gems_code = info.gems_code
      state.bkes_code = info.bkes_code
      state.address = info.alamat

      state.choosedCountry = info.negara
      state.choosedProvince = info.provinsi
      state.choosedCity = info.kota
      state.choosedDistric = info.kecamatan
      state.choosedVillage = info.kelurahan
      state.kodepos = info && info.kelurahan && info.kelurahan.kodepos
      state.provinsiAsing = info.provinsi_asing
      state.kotaAsing = info.kota_asing
      state.kodeposAsing = info.kode_pos_asing

      state.phoneCode = ''
      state.phoneNumber = info.no_handphone
      state.emailPerusahaan = info.email
      state.selectedBank = info.bank
      state.bankBranchOffice = info.kantor_cabang
      state.mataUang = info.mata_uang
      state.accountNumber = info.no_rekening
      state.npwpBank = info.no_npwp

      state.afiliasi_bce = info.afiliasi_bce
      state.afiliasi_gems = info.afiliasi_gems
      state.afiliasi_bkes = info.afiliasi_bkes

      state.relasi_desc = info.relasi_desc_bce
      state.relasi_group = info.relasi_group_bce
      state.relasi_nama = info.relasi_nama_bce
      state.relasi_jabatan = info.relasi_jabatan_bce
      state.relasi_departemen = info.relasi_departemen_bce
    },
    SET_CHECKED(state, checked) {
      state[checked.name] = checked.filter
    },
  },
  actions: {
    async getInformasi({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-informasi?id=${payload &&
          payload.vendor_id}`

        const { data } = await axios({
          method: 'GET',
          url,
        })
        await commit('SET_STATE_DATA', {
          name: 'vendor_id',
          value: payload.vendor_id,
        })
        await commit('SET_INFO', data.data)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async updateInformationValidation({ state, root }) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-informasi/${state.vendor_id}`
        let update = {
          badan_usaha_id: state.badan_usaha_id,
          nama_vendor: state.vendorName,
          tanggal_berdiri: state.tglBerdiri,
          alamat: state.address,
          negara_id: mixin.methods.$get(state, 'choosedCountry.id'),
          provinsi_id: mixin.methods.$get(state, 'choosedProvince.id'),
          kota_id: mixin.methods.$get(state, 'choosedCity.id'),
          kecamatan_id: mixin.methods.$get(state, 'choosedDistric.id'),
          kelurahan_id: mixin.methods.$get(state, 'choosedVillage.id'),
          provinsi_asing: state.provinsiAsing,
          kota_asing: state.kotaAsing,
          kode_pos_asing: state.kodeposAsing,
          no_handphone: state.phoneNumber,
          email: state.emailPerusahaan,
          nama_pemilik_rekening: state.vendorName,
          bank: state.selectedBank,
          kantor_cabang: state.bankBranchOffice,
          no_rekening: state.accountNumber,
          mata_uang: state.mataUang,
          no_npwp: state.npwpBank,
          ariba_code: state.ariba_code,
          bce_code: state.bce_code,
          gems_code: state.gems_code,
          bkes_code: state.bkes_code,
          isupplier_code: state.isupplier_code,
          afiliasi_bce: state.afiliasi_bce,
          afiliasi_gems: state.afiliasi_gems,
          afiliasi_bkes: state.afiliasi_bkes,
          relasi_desc_bce: state.relasi_desc,
          relasi_group_bce: state.relasi_group,
          relasi_nama_bce: state.relasi_nama,
          relasi_jabatan_bce: state.relasi_jabatan,
          relasi_departemen_bce: state.relasi_departemen,
          relasi_desc_gems: null,
          relasi_group_gems: null,
          relasi_nama_gems: null,
          relasi_jabatan_gems: null,
          relasi_departemen_gems: null,
          relasi_desc_bkes: null,
          relasi_group_bkes: null,
          relasi_nama_bkes: null,
          relasi_jabatan_bkes: null,
          relasi_departemen_bkes: null,
        }

        let json = JSON.stringify(update)
        const { data } = await axios.put(url, json, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        await store.commit('SET_NOTIF', `Update data vendor berhasil.`)
        await store.commit('addEdit/ADD_EDIT_MODAL', {
          name: 'showEditInfo',
          status: false,
        })
        await store.commit('editStore/SET_EDIT_INFO')
        await store.commit('modalStore/SET_MODAL_LEVEL1', false)
        await store.commit('level1/GET_INFO_DATA', 'informasi')
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async updateInformation({ state, root }) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-informasi/${state.vendor_id}`
        let update = {
          badan_usaha_id: state.badan_usaha_id,
          nama_vendor: state.vendorName,
          tanggal_berdiri: state.tglBerdiri,
          alamat: state.address,
          negara_id: mixin.methods.$get(state, 'choosedCountry.id'),
          provinsi_id: mixin.methods.$get(state, 'choosedProvince.id'),
          kota_id: mixin.methods.$get(state, 'choosedCity.id'),
          kecamatan_id: mixin.methods.$get(state, 'choosedDistric.id'),
          kelurahan_id: mixin.methods.$get(state, 'choosedVillage.id'),
          provinsi_asing: state.provinsiAsing,
          kota_asing: state.kotaAsing,
          kode_pos_asing: state.kodeposAsing,
          no_handphone: state.phoneNumber,
          email: state.emailPerusahaan,
          nama_pemilik_rekening: state.vendorName,
          bank: state.selectedBank,
          kantor_cabang: state.bankBranchOffice,
          no_rekening: state.accountNumber,
          mata_uang: state.mataUang,
          no_npwp: state.npwpBank,
          ariba_code: state.ariba_code,
          bce_code: state.bce_code,
          gems_code: state.gems_code,
          bkes_code: state.bkes_code,
          isupplier_code: state.isupplier_code,
          afiliasi_bce: state.afiliasi_bce,
          afiliasi_gems: state.afiliasi_gems,
          afiliasi_bkes: state.afiliasi_bkes,
          relasi_desc_bce: state.relasi_desc,
          relasi_group_bce: state.relasi_group,
          relasi_nama_bce: state.relasi_nama,
          relasi_jabatan_bce: state.relasi_jabatan,
          relasi_departemen_bce: state.relasi_departemen,
          relasi_desc_gems: null,
          relasi_group_gems: null,
          relasi_nama_gems: null,
          relasi_jabatan_gems: null,
          relasi_departemen_gems: null,
          relasi_desc_bkes: null,
          relasi_group_bkes: null,
          relasi_nama_bkes: null,
          relasi_jabatan_bkes: null,
          relasi_departemen_bkes: null,
        }

        let json = JSON.stringify(update)
        const { data } = await axios.put(url, json, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        await store.commit('SET_NOTIF', `Update data vendor berhasil.`)
        await store.commit('addEdit/ADD_EDIT_MODAL', {
          name: 'showEditInfo',
          status: false,
        })
        await store.commit('editStore/SET_EDIT_INFO')
        // await store.commit('modalStore/SET_MODAL_LEVEL1', false)
        // await router.push('/')
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async addItemKbli({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-kbli`
        let created = payload.kbliData

        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            vendor_id: payload.vendor_id,
            kbli_parent_id: created.parent_id,
            kbli_sub_id: created.id,
            nib: false,
            ss_izin: false,
            dokumen_lainnya: false,
          },
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteKbli({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-kbli/${payload.kbli_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addItemIujp({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-iujp`
        let created = payload.iujpData

        let dataInput = {
          vendor_id: payload.vendor_id,
          iujp_id: created.id,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })

        if (data && data.data) {
          await payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteIujp({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-iujp/${payload.iujp_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addItemSbujk({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-sbujk`

        let dataInput = {
          vendor_id: payload.vendor_id,
          sbujk_id: payload.sbujk_id,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })

        if (data && data.data) {
          await payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteSbujk({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        let url = `${api}/api/v1/d-vendor-sbujk/${payload.sbujk_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addItemIujptl({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-iujptl`

        let dataInput = {
          vendor_id: payload.vendor_id,
          iujptl_id: payload.iujptl_id,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })

        if (data && data.data) {
          await payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteIujptl({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        let url = `${api}/api/v1/d-vendor-iujptl/${payload.iujptl_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addItemInubbm({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-inu-bbm`

        let dataInput = {
          vendor_id: payload.vendor_id,
          inu_bbm_id: payload.inu_bbm_id,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })

        if (data && data.data) {
          await payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteInubbm({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        let url = `${api}/api/v1/d-vendor-inu-bbm/${payload.inu_bbm_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addPIC({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-pic`

        let dataInput = {
          vendor_id: payload.vendor_id,
          nama: payload.nama,
          no_handphone: payload.no_handphone,
          email: payload.email,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })
        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_PIC_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'picDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddPic', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async editPIC({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-pic/${payload.id}`

        let dataInput = {
          vendor_id: payload.vendor_id,
          nama: payload.nama,
          no_handphone: payload.no_handphone,
          email: payload.email,
        }

        const { data } = await axios({
          method: 'PUT',
          url,
          data: dataInput,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_PIC_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'picDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddPic', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deletePIC({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-pic/${payload.id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_PIC_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'picDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddPic', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addDirektur({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-direktur`

        let dataInput = {
          vendor_id: payload.vendor_id,
          jabatan: payload.jabatan,
          nama: payload.nama,
          no_handphone: payload.no_handphone,
          email: payload.email,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })
        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_DIREKTUR_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'direkturDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddDirektur', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async editDirektur({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-direktur/${payload.id}`

        let dataInput = {
          jabatan: payload.jabatan,
          nama: payload.nama,
          no_handphone: payload.no_handphone,
          email: payload.email,
        }

        const { data } = await axios({
          method: 'PUT',
          url,
          data: dataInput,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_DIREKTUR_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'direkturDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddDirektur', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteDirektur({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-direktur/${payload.id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_DIREKTUR_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'direkturDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddDirektur', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addKomisaris({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-komisaris`

        let dataInput = {
          vendor_id: payload.vendor_id,
          jabatan: payload.jabatan,
          nama: payload.nama,
          no_handphone: payload.no_handphone,
          email: payload.email,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })
        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_KOMISARIS_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'komisarisDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddKomisaris', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async editKomisaris({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-komisaris/${payload.id}`

        let dataInput = {
          jabatan: payload.jabatan,
          nama: payload.nama,
          no_handphone: payload.no_handphone,
          email: payload.email,
        }

        const { data } = await axios({
          method: 'PUT',
          url,
          data: dataInput,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_KOMISARIS_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'komisarisDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddKomisaris', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteKomisaris({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-komisaris/${payload.id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_KOMISARIS_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'komisarisDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddKomisaris', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addPemilikSaham({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-pemilik-saham`

        let dataInput = {
          vendor_id: payload.vendor_id,
          nama: payload.name,
          persen: payload.persen,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })
        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_SAHAM_MODAL', false)
        await commit('SET_STATE_DATA', {
          name: 'pemilikSahamDetail',
          value: null,
        })
        await commit('SET_STATE_DATA', {
          name: 'isAddPemilikSaham',
          value: false,
        })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async editPemilikSaham({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-pemilik-saham/${payload.id}`

        let dataInput = {
          nama: payload.name,
          persen: payload.persen,
        }

        const { data } = await axios({
          method: 'PUT',
          url,
          data: dataInput,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_SAHAM_MODAL', false)
        await commit('SET_STATE_DATA', {
          name: 'pemilikSahamDetail',
          value: null,
        })
        await commit('SET_STATE_DATA', {
          name: 'isAddPemilikSaham',
          value: false,
        })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deletePemilikSaham({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-pemilik-saham/${payload.id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_SAHAM_MODAL', false)
        await commit('SET_STATE_DATA', {
          name: 'pemilikSahamDetail',
          value: null,
        })
        await commit('SET_STATE_DATA', {
          name: 'isAddPemilikSaham',
          value: false,
        })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
  },
}

export default addEdit
